<ets-header
  [isBGWhite]="true"
  [headerState]="headerState"
  [showBackButton]="false"
>
</ets-header>
<ets-sne-split-screen
  [rightBackgroundColor]="APP_COLORS.white"
  [hideMobile]="'right'"
>
  <div class="left">
    <div class="flow-map-container">
      <h3 class="content-header">{{questionData?.contentHeader}}</h3>
      <img *ngIf="questionData?.flowMapImgs" class="flow-map-img" [src]="(isHandset$ | async ) ? questionData?.flowMapImgs?.mobile : questionData?.flowMapImgs?.desktop" alt="production flow map graph" />
      <img *ngIf="questionData?.operationsLog" class="operations-log" [src]="(isHandset$ | async) ? questionData?.operationsLog?.mobile : questionData?.operationsLog?.desktop" />
    </div>
  </div>
  <div class="right">
    <ets-sne-multi-choice-list
      [inputType]="questionData?.inputType"
      [headerQuestion]="questionData?.header"
      [mulChoiceOptions]="questionData?.multipleMulChoiceOptions"
      (selectSingleResponseEvent)="singleReponseQuestionHandler($event.questionIndex, $event.answer)"
    >
    </ets-sne-multi-choice-list>
  </div>
  </ets-sne-split-screen>
  <ets-sne-progress-bar
  [questionIndex]="moduleIndex"
  [moduleSize]="moduleSize"
  [overviewEnabled]="true"
  (overviewEmitter)="openInstructionModal()"
  (nextEmitter)="getNextQuestion()"
  [questionNum]="questionNum"
  [isButtonDisabled]="multiResponse.length !== questionData?.multipleMulChoiceOptions?.length"
>
  <ets-sne-multi-choice-list
    [inputType]="questionData?.inputType"
    [headerQuestion]="questionData?.header"
    [mulChoiceOptions]="questionData?.multipleMulChoiceOptions"
    (selectSingleResponseEvent)="singleReponseQuestionHandler($event.questionIndex, $event.answer)"
    [mobileCheck]="true"
  >
  </ets-sne-multi-choice-list>
</ets-sne-progress-bar>
<ets-modal
  [title]="instructionModal?.title"
  [showModal]="showInstructionModal"
  [list]="instructionModal?.pageList"
  (modalClose)="closeInstructionModal()"
>
</ets-modal>

